import styled from 'styled-components';
import { MediaQuery } from '../../../../theme/style-helpers';

const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    margin: ${({ noMargin }) => (noMargin ? '0' : '40px 0px 72px')};
    flex-wrap: wrap;
    
    &.has-children {
        justify-content: space-between;
    }

    &.has-only-child {
        justify-content: flex-end;

        ${MediaQuery.xSmall`
            padding-top: 16px;
            button{
                width: 100%;
            }
        `}
    }
`;

export default ButtonGroup;
